import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import Shapes from 'shapes/main';
import { EDeliveryStatus } from 'enums';
import { IDelivery } from 'types';

interface DriverDeliveryButtonsProps {
  delivery: IDelivery;
  changeStatus: (delivery: IDelivery, status: EDeliveryStatus) => void;
  requestDelay: (delivery: IDelivery) => void;
  proposeOtherTime: (delivery: IDelivery) => void;
}

const DriverDeliveryButtons = (props: DriverDeliveryButtonsProps) => {
  const { changeStatus, delivery, requestDelay, proposeOtherTime } = props;
  if (delivery.status === EDeliveryStatus.NEW) {
    return (
      <div className="row driver-deliveries-buttons-wrapper">
        <button
          className="btn btn-success nowrap mw-125"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            proposeOtherTime(delivery);
          }}
        >
          {i18next.t('driver-delivery-buttons.accept')}
        </button>
        <button
          className="btn btn-danger mw-125 nowrap"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            changeStatus(delivery, EDeliveryStatus.DECLINED);
          }}
        >
          {i18next.t('driver-delivery-buttons.decline')}
        </button>
      </div>
    );
  }

  const requestDelayBtn = (
    <button
      className="btn btn-info mw-200 nowrap"
      onClick={() => requestDelay(delivery)}
    >
      {i18next.t('driver-delivery-buttons.need-more-time')}
    </button>
  );

  if (delivery.status === EDeliveryStatus.ASSIGNED) {
    return (
      <div className="row driver-deliveries-buttons-wrapper">
        <button
          className="btn btn-success btn-block mw-150"
          onClick={() => changeStatus(delivery, EDeliveryStatus.ARRIVING)}
        >
          {i18next.t('driver-delivery-buttons.on-way-to-restaurant')}
        </button>
        {requestDelayBtn}
      </div>
    );
  }
  
  if (delivery.status === EDeliveryStatus.ARRIVING) {
    return (
      <div className="row driver-deliveries-buttons-wrapper">
        <button
          className="btn btn-success btn-block mw-150"
          onClick={() => changeStatus(delivery, EDeliveryStatus.ARRIVED)}
        >
          {i18next.t('driver-delivery-buttons.at-restaurant')}
        </button>
        {requestDelayBtn}
      </div>
    );
  }

  if (delivery.status === EDeliveryStatus.ARRIVED) {
    return (
      <button
        className="btn btn-success mw-150"
        onClick={() => changeStatus(delivery, EDeliveryStatus.ON_THE_WAY)}
      >
        {i18next.t('driver-delivery-buttons.on-the-way')}
      </button>
    );
  }

  if (delivery.status === EDeliveryStatus.ON_THE_WAY) {
    return (
      <button
        className="btn btn-success mw-150"
        onClick={() => changeStatus(delivery, EDeliveryStatus.DELIVERED)}
      >
        {i18next.t('driver-delivery-buttons.delivered')}
      </button>
    );
  }
  return null;
};

DriverDeliveryButtons.propTypes = {
  changeStatus: PropTypes.func.isRequired,
  delivery: Shapes.deliveryShape.isRequired,
  requestDelay: PropTypes.func.isRequired,
  proposeOtherTime: PropTypes.func.isRequired,
};

export default DriverDeliveryButtons;
